<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ManChargeRateInfo"
                :filter_thousandth="['man_rate','charge_rate']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_year" :label="$t('getapi[1974]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_month" :label="$t('getapi[1975]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[4361]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[882]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="man_rate" :label="$t('getapi[7557]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="charge_rate" :label="$t('getapi[7558]')" align="right"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ManChargeRateInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6639]')" queryData="ManChargeRateInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_stdrate',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_stdrate'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('ManChargeRateInfo',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6639]"),this.$t("getapi[6633]"));
            },
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_stdrate',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ManChargeRateInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/StdCost/GetStdRateView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true
                that.$http.urlpost('/Fin/StdCost/GetStdRateViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        that.loading = false
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ManChargeRateInfo",
                    fromname: that.$t('getapi[6639]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
